import { HttpService, createHttpService } from '@/services/HttpService';

type MeResponse = {
  id: string;
  tenant_id: string;
};

type AccessPolicy = {
  role_id: string;
};

type AccessPoliciesResponse = {
  items: AccessPolicy[];
};

export const PERMISSION_ROLES = {
  edit: ['accounts_admin', 'partner_admin', 'company_admin', 'root_admin'],
  deleteAccount: ['company_admin', 'root_admin'],
  accessWizard: ['accounts_admin', 'partner_admin']
};


export enum Permissions {
  edit = 'edit',
  deleteAccount = 'deleteAccount',
  accessWizard = 'accessWizard'
}

export type UserPermissions = [
  Permissions.accessWizard?,
  Permissions.deleteAccount?,
  Permissions.edit?
];

export class UserPermissionsService {
  constructor(private httpService: HttpService) {
  }

  public async getUserPermissions(): Promise<UserPermissions> {
    try {
      const me: MeResponse = await this.httpService.get<void, MeResponse>('/api/2/users/me');
      const accessPolicies: AccessPoliciesResponse = await this.httpService.get<void, AccessPoliciesResponse>(
        `/api/2/users/${me.id}/access_policies`
      );
      return this.extractUserPermissions(accessPolicies.items);
    } catch (error) {
      return [];
    }
  }

  private extractUserPermissions(accessPolicies: AccessPolicy[]): UserPermissions {
    const userPermissions: UserPermissions = [];
    Object.values(Permissions).forEach((value) => {
      if (this.hasUserRoles(accessPolicies, PERMISSION_ROLES[value])) {
        userPermissions.push(value);
      }
  });
    return userPermissions;
  }

  private hasUserRoles(accessPolicies: AccessPolicy[], adminRoles: string[]): boolean {
    const roles: string[] = accessPolicies.map((accessPolicy: AccessPolicy): string => accessPolicy.role_id);

    return roles.some((role: string): boolean => adminRoles.includes(role));
  }
}

export function createUserPermissionsService(): UserPermissionsService {
  const httpService: HttpService = createHttpService();

  return new UserPermissionsService(httpService);
}
